<template>
  <div>
    <EquipmentLog />
  </div>
</template>

<script>
import EquipmentLog from '../components/EquipmentLog';
import DefaultLayout from "../layouts/DefaultLayout";

export default {
  components: {
    EquipmentLog
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
